var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
export function getLastRunForInspection(inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(`/api/internal/iim_runs/last`, {
                params: {
                    inspection_id: inspectionId
                }
            });
            return response.data.iim_run;
        }
        catch (error) {
            console.error('Error getting last IIM run for inspection:', error);
            throw error;
        }
    });
}
export function updatePublishedForRun(runId, published) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(`/api/internal/iim_runs/${runId}/update_published`, {
                published
            });
            return response.data.iim_run;
        }
        catch (error) {
            console.error('Error updating IIM run published status:', error);
            throw error;
        }
    });
}
